import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { Subscriber } from '../../_models';
import { SubscriberService, AuthenticationService, NotificationService, KeywordService } from '../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-subscriber-client',
  templateUrl: './subscriber.component.html'
})
export class ClientSubscriberComponent implements OnInit {
  subRecords: Subscriber[];
  selectedSub: Subscriber;
  loading = false;
  processing = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  filterable = {
    fromDate: '',
    phone: '',
    toDate: new Date().toISOString().substring(0, 10),
    unsubFlag: null,
    shortCode: '',
    keyword: null,
    affiliate: ''
  };

  selectedOperator = '';
  keywordList: any = [];
  shortCodeList: any = [];
  operatorList: any = [];
  affiliateList = [];
  flagList = { "Subscribe Date": false, "Unsubscribe Date": true };

  exporting = false;
  downloadUrl = '';
  selectedCountry = '';
  selectedFlag = "Sub";

  constructor(private authSvc: AuthenticationService,
    private subscriberSvc: SubscriberService,
    private notification: NotificationService,
    private keywordSvc: KeywordService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable.fromDate = dte.toISOString().substring(0, 10);
    this.loadOperator();
  }

  search() {
    this.totalItems = 0;
    this.loadPage(1);
  }

  clear(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 7);
    this.filterable = {
      fromDate: dte.toISOString().substring(0, 10),
      phone: '',
      toDate: new Date().toISOString().substring(0, 10),
      unsubFlag: '',
      shortCode: '',
      keyword: null,
      affiliate: ''
    };
    this.affiliateList = [];
    this.keywordList = [];
    this.shortCodeList = [];
    this.operatorList = [];
    this.loadOperator();
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onClear() {
    this.filterable.shortCode = "";
    this.filterable.keyword = null;
    this.filterable.affiliate = '';
    this.keywordList = [];
    this.affiliateList = [];
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.subscriberSvc.exportForClient(params)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  changeFlag(flag) {
    this.filterable.unsubFlag = flag == "true" ? true : false;;
  }

  loadOperator() {
    this.keywordSvc.getSelectionShortCodesForClient().subscribe(data => {
      this.operatorList = data.data;
      this.changeOperator(Object.keys(this.operatorList)[0]);
    });
  }

  changeOperator(operator) {
    this.selectedOperator = operator;
    if (this.filterable.shortCode) {
      this.filterable.shortCode = null;
      this.filterable.keyword = null;
      this.filterable.affiliate = '';
    }
    if (operator) {
      this.keywordList = [];
      this.affiliateList = [];
      this.shortCodeList = this.operatorList[operator];
      this.filterable.shortCode = this.shortCodeList[0];
      this.changeShortCode(this.filterable.shortCode);
    }
  }

  changeShortCode(shortCode) {
    if (shortCode) {
      this.filterable.keyword = null;
      this.filterable.affiliate = '';
      this.affiliateList = [];
      this.keywordSvc.getSelectionKwsForClient(this.selectedOperator, shortCode).subscribe(data => {
        this.keywordList = data.data;
        this.filterable.keyword = this.keywordList[0];
        this.changeKeyword(this.filterable.keyword);
      });
    }
  }

  changeKeyword(keyword){
    if(this.filterable.affiliate){
      this.filterable.affiliate = '';
    }
    this.affiliateList = keyword.affiliates;
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.subRecords = [];
    let params = this.formParam(page);
    // get page of items from api
    this.subscriberSvc.getAllForClient(params).pipe(first()).subscribe(data => {
      if (data.status !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.subRecords = data.data.list;
        this.totalItems = data.data.total;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      fromDate: formatDate(this.filterable.fromDate, 'yyyyMMdd', 'en'),
      phone: this.filterable.phone,
      toDate: formatDate(this.filterable.toDate, 'yyyyMMdd', 'en'),
      unsubFlag: this.filterable.unsubFlag == null ? false : this.filterable.unsubFlag,
      shortCode: this.filterable.shortCode,
      keyword: this.filterable.keyword == null? "" : this.filterable.keyword.keyword,
      operator: this.selectedOperator,
      affiliate: this.filterable.affiliate
    }
    return params;
  }

}
